import SectionLabel from "@/components/base/SectionLabel";
import { caseStudiesData } from "@/mocks/caseStudiesData";

export default function OurApproachSection() {
  return (
    <section id="approach" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14 reveal">
          <SectionLabel
            label={caseStudiesData.approach.label}
            className="mb-3"
          />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {caseStudiesData.approach.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 max-w-4xl mx-auto mb-8 md:mb-10">
          {caseStudiesData.approach.items.map((item, idx) => (
            <div
              key={item.num}
              className="reveal flex flex-col p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70"
              style={{ transitionDelay: `${idx * 80}ms` }}
            >
              <span className="text-2xl md:text-3xl font-bold font-heading text-primary-500/30 mb-3">
                {item.num}
              </span>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 font-heading">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="reveal max-w-2xl mx-auto text-center">
          <div className="inline-block px-6 py-3.5 md:px-8 md:py-4 rounded-lg bg-primary-50 border border-primary-200/50">
            <p className="text-sm md:text-base font-bold text-primary-700 leading-relaxed font-heading">
              {caseStudiesData.approach.bottomText}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}